export const responsiveScreens = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
  // never used but ensured that for very big screens at least this breakpoint will be used
  '99xl': '999999px',
}
